<template>
  <div>
    <div id="captcha"></div>
  </div>
</template>

<script>
export default {
  name: "SmartCaptcha",
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ic: null
    }
  },
  methods: {
    initCaptcha() {
      const that = this
      // eslint-disable-next-line
      AWSC.use("ic", function (state, module) {
        that.ic = module.init({
          appkey: 'FFFF0N0N000000009186',
          scene: 'ic_login',
          renderTo: '#captcha',
          width: 358,
          success: function (data) {
            that.$emit('verifySuccess', data)
          },
          // 验证失败时触发该回调参数
          fail: function (failCode) {
            console.log(failCode)
          },
          // 验证码加载异常时触发该回调参数
          error: function (errorCode) {
            console.log(errorCode)
          }
        })
      })
    },
    reloadSmartCaptcha() {
      this.ic.reset()
    }
  },
  mounted() {
    this.initCaptcha()
  }
}
</script>

<style scoped>

</style>

